import React from 'react';
import PropTypes from 'prop-types';
import Configuration from '../../../common/Configuration.json';

const FirstPlanPaymentDescription = ({ hasSubscriptionDiscount }) => {
  const getFirstPlanPaymentDescription = () => {
    const descriptionBasedOnDiscountStatus = hasSubscriptionDiscount ?
      `${Configuration.subscriptionDiscount.durationString} after`
      : 'on';
    return `FYI: Your first plan payment will be taken from your card ${
       descriptionBasedOnDiscountStatus
   } the day your connection is up and running.`;
  };

  return (<p className="gray-container-left-content">
    <small>{getFirstPlanPaymentDescription()}</small>
  </p>);
};

FirstPlanPaymentDescription.propTypes = {
  hasSubscriptionDiscount: PropTypes.bool,

};

export default FirstPlanPaymentDescription;



/** WEBPACK FOOTER **
 ** ./src/components/payment/Order/FirstPlanPaymentDescription.js
 **/